import React from "react";
import { Route, Routes } from "react-router-dom";

import PrivateRoute from "components/PrivateRoute";
import Home from "pages/Home";
import DashboardLayout from "pages/dashboards/DashboardLayout";
import PageNotFound from "pages/PageNotFound";
import { useMediaQuery } from "react-responsive";
import { useDashboardRoutes } from "hooks/useDashboardRoutes";
import { renderDashboardRoutes } from "routes/renderDashboardRoutes";
import "./Admin.scss";

const AdminDashboardLayout = () => {
  const isSmallScreen = useMediaQuery({ maxWidth: 767 });
  const routes = useDashboardRoutes({ isAdminDashboard: true });
  return (
    <DashboardLayout
      isAdminDashboard={true}
      isSmallScreen={isSmallScreen}
      color="silver"
      routes={routes}
    />
  );
};

const AdminRoutes = ({ isAuthenticated }: { isAuthenticated?: boolean }) => {
  const dashboardRoutes = useDashboardRoutes({ isAdminDashboard: true });
  return (
    <>
      {!isAuthenticated && (
        <div className="mega-container">
          <section className="page-title-wrap">
            <article className="text-cell">
              <h1 className="page-title">
                Please contact your manager to create an Admin account.
              </h1>
            </article>
          </section>
        </div>
      )}
      <Routes>
        <Route
          element={<PrivateRoute path="/*" component={AdminDashboardLayout} />}
        >
          {renderDashboardRoutes(dashboardRoutes)}
        </Route>
        <Route
          path="/login"
          element={<PrivateRoute path="/login" component={Home} />}
        />
        <Route
          path="*"
          element={<PrivateRoute path="*" component={PageNotFound} />}
        />
      </Routes>
    </>
  );
};

export default AdminRoutes;
